module.exports = __webpack_public_path__ + "img/alipay-circle.f10775ab.svg";